import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import GeoGate from './GeoGate';
import reportWebVitals from './reportWebVitals';
import { watchForStaleTab } from './staleTabWatch';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GeoGate>
      <App />
    </GeoGate>
  </React.StrictMode>
);

// ── A TAB RUNNING YESTERDAY'S CODE CANNOT BE FIXED FROM THE SERVER ────────────
//
// See src/staleTabWatch.js for what this cost: a tab open from before the backend moved
// kept calling the retired host for days, and the failure surfaced as a CORS error on a
// screen nobody uses daily.
//
// Deliberately NOT a React component. It must work when the app's own state is wedged, and
// App.js is where a wedge would be; a plain DOM node attached to body has nothing to go
// wrong. It also means no edit to a 60,000-line file to add a banner.
watchForStaleTab(({ running, deployed }) => {
  if (document.getElementById('survai-stale-tab')) return;

  const bar = document.createElement('div');
  bar.id = 'survai-stale-tab';
  bar.setAttribute('role', 'status');
  bar.setAttribute('aria-live', 'polite');
  bar.style.cssText = [
    'position:fixed', 'left:0', 'right:0', 'bottom:0', 'z-index:2147483647',
    'display:flex', 'align-items:center', 'gap:12px', 'flex-wrap:wrap',
    'padding:12px 16px', 'background:#1f2937', 'color:#f9fafb',
    'font:500 14px/1.45 system-ui,-apple-system,Segoe UI,sans-serif',
    'box-shadow:0 -2px 12px rgba(0,0,0,.28)',
  ].join(';');

  const text = document.createElement('span');
  text.style.cssText = 'flex:1 1 320px';
  // SAYS WHAT WENT WRONG AND WHAT IT BREAKS, not "a new version is available". The whole
  // reason this exists is that the symptom was unrecognisable: saving appeared to work and
  // administration failed with a CORS error. Somebody reading this bar at 7pm needs to know
  // their unsaved work is safe and what will keep failing until they reload.
  text.textContent =
    'This tab is running an older version of SurvAIHealth. Anything you have already typed is safe, ' +
    'but saving and user administration may fail until you reload.';

  const reload = document.createElement('button');
  reload.type = 'button';
  reload.textContent = 'Reload now';
  reload.style.cssText = [
    'flex:0 0 auto', 'padding:8px 14px', 'border:0', 'border-radius:6px',
    'background:#2563eb', 'color:var(--ed-canvas)', 'font:600 14px/1 inherit', 'cursor:pointer',
  ].join(';');
  // location.reload() can be served from cache. Replacing the URL forces a fresh document,
  // which is the entire point of the button.
  reload.onclick = () => window.location.replace(window.location.pathname + window.location.search);

  const later = document.createElement('button');
  later.type = 'button';
  later.textContent = 'Not now';
  later.setAttribute('aria-label', 'Dismiss this notice and keep working');
  later.style.cssText = [
    'flex:0 0 auto', 'padding:8px 10px', 'border:0', 'background:transparent',
    'color:var(--ed-line-hover)', 'font:500 13px/1 inherit', 'cursor:pointer', 'textDecoration:underline',
  ].join(';');
  // Dismissible, and it does not come back in this tab. An operator mid-attestation has a
  // better reason to finish than this has to interrupt, and a notice that reappears every
  // ten minutes is one people learn to click past without reading.
  later.onclick = () => bar.remove();

  bar.append(text, reload, later);
  document.body.appendChild(bar);

  // In the console too, with both filenames, because that is where whoever is debugging a
  // report of "it just says failed to fetch" will be looking.
  console.warn(
    `[survai] This tab is running ${running} but the server is serving ${deployed}. ` +
      `Reload to pick up the current build. Calls to a retired backend host fail as CORS ` +
      `errors rather than anything that names the real cause.`,
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
